import $ from 'jquery';
import { initProductTileItem } from './basket';

$(function() {

    initHeroCarousel();
    setImageOrientation();
    initHeroCarouselPlay();
});

$(window).resize(function() {
    initHeroCarousel();
});

function heroCarouselScrollNext() {
    let next = $('.hero-carousel .control.next').first();

    next.click();
}

function initHeroCarouselPlay() {
    setInterval(heroCarouselScrollNext, 3000);
}

function initHeroCarousel() {

    let height = 0;

    $('.hero-carousel .slide').each(function(){
        let slideHeight = $(this).outerHeight();

        if(slideHeight > height){
            height = slideHeight;
        }
    });

    $('.hero-carousel').css('padding-top', height);

    $('.hero-carousel .control').unbind('click');
    $('.hero-carousel .control').on('click', function(e) {
        // Stop click event bubbling
        e.stopPropagation();
        e.preventDefault();
        // trigger the slide function
        if ($(this).hasClass('next')) {
            heroCarouselSlide('next');
        } else {
            heroCarouselSlide('previous');
        }
    });

    $('.hotspot').unbind('click');
    $('.hotspot').on('click', function() {
        showHotspotProductTile($(this));
    });

}


function heroCarouselSlide(direction) {

    // Clear any open hotspot product tiles
    hideHotspotProductTiles();

    if (!direction) {
        direction = 'next';
    }

    let $heroCarousel = $('.hero-carousel');
    let $slides = $heroCarousel.find('.slides');
    let slideCount = $slides.find('.slide').length;
    let currentId = parseInt($slides.find('.current').attr('data-id'));

    // Set the new current slide id
    if (direction === 'next') {
        currentId = modifyId(currentId, 1, slideCount);
    } else {
        currentId = modifyId(currentId, -1, slideCount);
    }

    $slides.find('.slide').removeClass('next-1 next-2 current previous-2 previous-1');

    $slides.find('.slide[data-id=' + currentId + ']').addClass('current');
    if (slideCount > 1) {
        $slides.find('.slide[data-id=' + modifyId(currentId, 1, slideCount) + ']').addClass('next-1');
    }
    if (slideCount === 3) {
        $slides.find('.slide[data-id=' + modifyId(currentId, -1, slideCount) + ']').addClass('previous-1');
    } else if (slideCount > 3) {
        $slides.find('.slide[data-id=' + modifyId(currentId, 2, slideCount) + ']').addClass('next-2');
        $slides.find('.slide[data-id=' + modifyId(currentId, -1, slideCount) + ']').addClass('previous-1');
    }
    if (slideCount > 4) {
        $slides.find('.slide[data-id=' + modifyId(currentId, -2, slideCount) + ']').addClass('previous-2');
    }

    setImageOrientation();

    videoSlideSetPlay();

}

function modifyId(id, delta, slideCount) {

    let modifiedId = id;
    if (delta < 0) {
        modifiedId = (id + delta);
        if (modifiedId < 0) { (modifiedId += slideCount); }
    } else {
        modifiedId = (id + delta);
        if (modifiedId >= slideCount) { (modifiedId -= slideCount); }
    }

    return modifiedId;

}


function videoSlideSetPlay() {

    $('.hero-carousel .ytApiPlayer iframe').each(function() {

        try {
            let $iframe = $(this);
            let uid = $iframe.attr('id');
            let player = window.carouselVideos[uid];
            if ($iframe.closest('.slide').hasClass('current')) {
                player.playVideo();
            } else {
                player.pauseVideo();
            }
        } catch (err) {
            console.log('YT error: ' + err.message);
        }

    });

}


function setImageOrientation() {

    $('.hero-carousel .image-wrapper, .hero-slider .image-wrapper').each(function() {

        let $wrapper = $(this);
        let wrapperRatio = ($wrapper.outerWidth() / $wrapper.outerHeight());

        let $image = $(this).find('img');
        let imageWidth = $image.attr('data-width');
        let imageHeight = $image.attr('data-height');
        let imageRatio = (imageWidth / imageHeight);

        if (imageRatio < wrapperRatio) {
            $wrapper.find('.image-outer').removeClass('landscape').addClass('portrait');
        } else {
            $wrapper.find('.image-outer').removeClass('portrait').addClass('landscape');
        }

    });

}

function showHotspotProductTile($hotspot) {
    console.log('showHotspotProductTile');showHotspotProductTile
    let open = (!$hotspot.hasClass('open'));

    // Clear any open hotspots
    hideHotspotProductTiles();

    if (!open) {
        return;
    }

    $hotspot.addClass('open');

    let $productTile = $hotspot.find('.hotspot-product-tile');
    let position = $productTile.parent().offset();

    // Clone the product tile
    let $clone = $productTile.clone();
    $('body').append($clone);

    // Get tile dimensions
    let tileWidth = $clone.outerWidth();
    let tileHeight = $clone.outerHeight();

    // Get viewport dimensions
    let viewportWidth = $(window).width();
    let viewportHeight = $(window).height();

    // Adjust position to keep the tile in view
    let left = position.left;
    let top = position.top;

    if (left + tileWidth > viewportWidth) {
        left = viewportWidth - tileWidth - 10; // small margin
    }
    if (left < 0) {
        left = 10;
    }

    if (top + tileHeight > viewportHeight + $(window).scrollTop()) {
        top = viewportHeight + $(window).scrollTop() - tileHeight - 10;
    }
    if (top < $(window).scrollTop()) {
        top = $(window).scrollTop() + 10;
    }

    console.log(top, left, tileWidth, tileHeight, viewportWidth, viewportHeight);

    // Apply adjusted position
    $clone.css({
        top: top,
        left: left
    });

    setTimeout(function() {
        $clone.css('opacity', '1');
    }, 10);

    // Initialise the mobile only close button
    $('.hotspot-product-tile .close-mobile').unbind('click');
    $('.hotspot-product-tile .close-mobile').on('click', function() {
        hideHotspotProductTiles();
    });

    // Initialise the add-item button
    initProductTileItem();
    initOfferDetail();

}

function hideHotspotProductTiles() {

    $('.hotspot.open').removeClass('open');
    let $openProductTiles = $('body > .hotspot-product-tile');

    $openProductTiles.css('opacity', '0');
    setTimeout(function() {
        $openProductTiles.remove();
    }, 1000);

}

window.addEventListener('resize', function() {

    // reposition hotspot product tile on window resize

    $('body > .hotspot-product-tile').each(function() {
        let $hotspotProductTile = $(this);
        let hotspotId = $hotspotProductTile.attr('data-id');
        let $hotspot = $('.hotspot[data-id=' + hotspotId + ']');
        let position = $hotspot.offset();
        $hotspotProductTile.css(position);
    });

});
